import React from 'react';
export default function fileRender(value) {
  if (!value) {
    return '';
  }
  if (!value.length || !value.splice) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#F04631'
      }
    }, "\u6570\u636E\u683C\u5F0F\u4E0D\u5408\u89C4\uFF0C\u8BF7\u8FD4\u56DE\u6570\u7EC4\u5F62\u5F0F\uFF01");
  }
  return value.map(function (file) {
    return /*#__PURE__*/React.createElement("a", {
      key: file.name,
      style: {
        display: 'inline-block',
        margin: '0 5px'
      },
      title: file.name,
      className: "overflow-hidden-cell",
      href: file.url
    }, file.name);
  });
}
;